
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt-br/contato",
      function () {
        return require("private-next-pages/pt-br/contato/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt-br/contato"])
      });
    }
  